export enum AttachmentTypes {
  FIREBASE_STORAGE_ATTACHMENT = 'FIREBASE_STORAGE_ATTACHMENT',
}

export enum BeaconEventShareTypes {
  CONNECTION = 'CONNECTION',
  COPYLINK = 'COPYLINK',
  EMAIL = 'EMAIL',
}

export enum BeaconEventTypes {
  IMPRESSION = 'IMPRESSION',
  RESPONSE = 'RESPONSE',
  SHARE = 'SHARE',
}

export enum BeaconStatuses {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export enum CategoryTypes {
  ACT_TYPES = 'actTypes',
  BADGES = 'badges',
  COUNTRIES = 'countries',
  DISABILITIES = 'disabilities',
  GENDERS = 'genders',
  GENRES = 'genres',
  IDENTITIES = 'identities',
  MUSIC_TYPES = 'musicTypes',
  SEXUALITIES = 'sexualities',
  SHOW_SALES_RESTRICTIONS = 'showSalesRestrictions',
  VENUE_SIZES = 'venueSizes',
  VENUE_TYPES = 'venueTypes',
}

export enum ChatTypes {
  THREAD_CHAT = 'THREAD_CHAT',
  SHOW_CHAT = 'SHOW_CHAT',
}

export enum CheckoutSessionTypes {
  ONLINE_SHOW_SUPPORT_FEE = 'ONLINE_SHOW_SUPPORT_FEE',
  TICKET_PURCHASE = 'TICKET_PURCHASE',
}

export enum CheckoutStatuses {
  PAID = 'paid',
  UNPAID = 'unpaid',
  NO_PAYMENT_REQUIRED = 'no_payment_required',
}

export enum Currencies {
  AUD = 'AUD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
  BRL = 'BRL',
  CHF = 'CHF',
  DKK = 'DKK',
  HKD = 'HKD',
  JPY = 'JPY',
  NOK = 'NOK',
  NZD = 'NZD',
  SEK = 'SEK',
  SGD = 'SGD',
}

export enum EmailRecordTypes {
  OPEN = 'Open',
  CLICK = 'Click',
  DELIVERY = 'Delivery',
  BOUNCE = 'Bounce',
  SPAM = 'SpamComplaint',
}

export enum FirestoreChangeTypes {
  FIRESTORE_CHANGE_TYPE_ADDED = 'added',
  FIRESTORE_CHANGE_TYPE_MODIFIED = 'modified',
  FIRESTORE_CHANGE_TYPE_REMOVED = 'removed',
}

export enum FirestoreInstanceTypes {
  INSTANCE_TYPE_CLIENT = 'INSTANCE_TYPE_CLIENT',
  INSTANCE_TYPE_ADMIN = 'INSTANCE_TYPE_ADMIN',
}

export enum JobTypes {
  JOB_TYPE_CANCEL_SHOW = 'JOB_TYPE_CANCEL_SHOW',
  JOB_TYPE_CREATE_UPCOMING_SHOWS_NOTIFICATION_SET = 'JOB_TYPE_CREATE_UPCOMING_SHOWS_NOTIFICATION_SET',
  JOB_TYPE_CREATE_SHOW_NOTIFICATION_SET = 'JOB_TYPE_CREATE_SHOW_NOTIFICATION_SET',
  JOB_TYPE_CREATE_REVIEW_NOTIFICATION_SET = 'JOB_TYPE_CREATE_REVIEW_NOTIFICATION_SET',
  JOB_TYPE_EXPIRE_BEACON = 'JOB_TYPE_EXPIRE_BEACON',
  JOB_TYPE_BEACON_STATS = 'JOB_TYPE_BEACON_STATS',
  JOB_TYPE_INITIATE_PAYOUT = 'JOB_TYPE_INITIATE_PAYOUT',
  JOB_TYPE_SHOW_CRON = 'JOB_TYPE_SHOW_CRON',
  JOB_TYPE_SHOW_DETAILS_UPDATE = 'JOB_TYPE_SHOW_DETAILS_UPDATE',
  JOB_TYPE_UPDATE_ORDERS = 'JOB_TYPE_UPDATE_ORDERS',
  JOB_TYPE_SETTLEMENT_PDF = 'JOB_TYPE_SETTLEMENT_PDF',
  JOB_TYPE_TOGGLE_USER_ARCHIVE = 'JOB_TYPE_TOGGLE_USER_ARCHIVE',
  JOB_TYPE_TOGGLE_USER_ARCHIVE_SCHEDULE = 'JOB_TYPE_TOGGLE_USER_ARCHIVE_SCHEDULE',
  JOB_TYPE_REFRESH_THIRD_PARTY_METADATA = 'JOB_TYPE_REFRESH_THIRD_PARTY_METADATA',
  JOB_TYPE_MERGE_THREADS = 'JOB_TYPE_MERGE_THREADS',
}

export enum LookupSources {
  LOOKUP_SOURCE_IP = 'LOOKUP_SOURCE_IP',
  LOOKUP_SOURCE_GEOLOC = 'LOOKUP_SOURCE_GEOLOC',
}

/**
 * @deprecated
 */
export enum NotificationFrequencies {
  NOTIFICATION_FREQUENCY_DAILY = 'NOTIFICATION_FREQUENCY_DAILY',
  NOTIFICATION_FREQUENCY_IMMEDIATELY = 'NOTIFICATION_FREQUENCY_IMMEDIATELY',
  NOTIFICATION_FREQUENCY_NEVER = 'NOTIFICATION_FREQUENCY_NEVER',
  NOTIFICATION_FREQUENCY_THREE_HOURS = 'NOTIFICATION_FREQUENCY_THREE_HOURS',
  NOTIFICATION_FREQUENCY_WEEKLY = 'NOTIFICATION_FREQUENCY_WEEKLY',
}

export enum NotificationTypes {
  NOTIFICATION_TYPE_UPCOMING_SHOWS = 'NOTIFICATION_TYPE_UPCOMING_SHOWS',
  NOTIFICATION_TYPE_ARTIST_BEACON = 'NOTIFICATION_TYPE_ARTIST_BEACON',
  NOTIFICATION_TYPE_MESSAGE = 'NOTIFICATION_TYPE_MESSAGE',
  NOTIFICATION_TYPE_NEW_REVIEW = 'NOTIFICATION_TYPE_NEW_REVIEW',
  NOTIFICATION_TYPE_ACCOUNT_UPDATE = 'NOTIFICATION_TYPE_ACCOUNT_UPDATE',
  NOTIFICATION_TYPE_SHOW_UPDATE = 'NOTIFICATION_TYPE_SHOW_UPDATE',
  NOTIFICATION_TYPE_SHOW_CALL_UPDATE = 'NOTIFICATION_TYPE_SHOW_CALL_UPDATE',
  NOTIFICATION_TYPE_SALES_DIGEST = 'NOTIFICATION_TYPE_SALES_DIGEST',

  /**
   * @deprecated
   */
  NOTIFICATION_TYPE_SHOW_CANCELLATION = 'NOTIFICATION_TYPE_SHOW_CANCELLATION',

  /**
   * @deprecated
   */
  NOTIFICATION_TYPE_PAYOUT = 'NOTIFICATION_TYPE_PAYOUT',
}

export enum OrderStatuses {
  SUCCEEDED = 'succeeded',
  REFUNDED = 'refunded',
  PAID = 'paid',
  CANCELLED = 'canceled',
  FAILED = 'failed',
  REQUIRES_CONFIRMATION = 'requires_confirmation',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
}

/**
 * These statuses corresponded to the now-deprecated Stripe Order API
 * @deprecated
 */
export enum DeprecatedOrderStatuses {
  CREATED = 'created',
  FULFILLED = 'fulfilled',
  PURCHASED = 'purchased',
  RETURNED = 'returned',
  COMPED = 'comped',
}

/**
 * @deprecated To be removed when a show can have multiple products
 */
export enum OrderTypes {
  ORDER_TYPE_ADVANCE = 'STRIPE_ORDER_TYPE_ADVANCE',
  ORDER_TYPE_DOOR = 'STRIPE_ORDER_TYPE_DOOR',
  ORDER_TYPE_COMP = 'STRIPE_ORDER_TYPE_COMP',
}

export enum PayoutRecipients {
  PAYOUT_ARTIST = 'PAYOUT_ARTIST',
  PAYOUT_HOST = 'PAYOUT_HOST',
  PAYOUT_SIDEDOOR = 'PAYOUT_SIDEDOOR',
  PAYOUT_DEPOSIT_REFUND = 'PAYOUT_DEPOSIT_REFUND',
  PAYOUT_PENDING = 'PAYOUT_PENDING',
}

export enum PayoutStatuses {
  PAYOUT_WAITING = 'PAYOUT_WAITING',
  PAYOUT_PENDING = 'PAYOUT_PENDING',
  BILLING_ERROR = 'BILLING_ERROR',
  PAYOUT_PAID = 'PAYOUT_PAID',
  PAYOUT_SKIPPED = 'PAYOUT_SKIPPED',
}

export enum PDFStatuses {
  GENERATED = 'GENERATED',
  GENERATING = 'GENERATING',
}

export enum ProductTypes {
  PRODUCT_MERCH = 'PRODUCT_MERCH',
  PRODUCT_ONLINE_ACCESS = 'PRODUCT_ONLINE_ACCESS',
  PRODUCT_PHYSICAL_ACCESS = 'PRODUCT_PHYSICAL_ACCESS',
  PRODUCT_TYPE_GROUP_PASS = 'PRODUCT_TYPE_GROUP_PASS',
}

export enum ShowAnnounceModes {
  IMMEDIATELY = 'IMMEDIATELY',
  SCHEDULED = 'SCHEDULED',
}

export enum SignupIntents {
  ARTIST = 'artist',
  AUDIENCE = 'audience',
  FOLLOW = 'follow',
  INVITE = 'invite',
  PRESENTER = 'presenter',
  VENUE = 'venue',
}

export enum SitemapTypes {
  ACT = 'ACT',
  SHOW = 'SHOW',
  SHOWCALL = 'SHOWCALL',
  SHOWGROUP = 'SHOWGROUP',
  VENUE = 'VENUE',
}

export enum SoundCheckOptions {
  SOUNDCHECK_NO = 'SOUNDCHECK_NO',
  SOUNDCHECK_YES = 'SOUNDCHECK_YES',
}

export enum ThreadEventTypes {
  THREAD_EVENT_START = 'THREAD_EVENT_START',
  THREAD_EVENT_REQUEST_APPROVAL_DATE = 'THREAD_EVENT_REQUEST_APPROVAL_DATE',
  THREAD_EVENT_REQUEST_APPROVAL_TICKET = 'THREAD_EVENT_REQUEST_APPROVAL_TICKET',
  THREAD_EVENT_REQUEST_APPROVAL_OTHER = 'THREAD_EVENT_REQUEST_APPROVAL_OTHER',
  THREAD_EVENT_REQUEST_APPROVAL_SIGN = 'THREAD_EVENT_REQUEST_APPROVAL_SIGN',
  THREAD_EVENT_REQUEST_SHOW_GROUP_APPROVAL_SIGN = 'THREAD_EVENT_REQUEST_SHOW_GROUP_APPROVAL_SIGN',
  THREAD_EVENT_UNLOCK_DATE = 'THREAD_EVENT_UNLOCK_DATE',
  THREAD_EVENT_UNLOCK_TICKET = 'THREAD_EVENT_UNLOCK_TICKET',
  THREAD_EVENT_UNLOCK_OTHER = 'THREAD_EVENT_UNLOCK_OTHER',
  THREAD_EVENT_UNLOCK_SIGN = 'THREAD_EVENT_UNLOCK_SIGN',
  THREAD_EVENT_APPROVED_DATE = 'THREAD_EVENT_APPROVED_DATE',
  THREAD_EVENT_APPROVED_TICKET = 'THREAD_EVENT_APPROVED_TICKET',
  THREAD_EVENT_APPROVED_OTHER = 'THREAD_EVENT_APPROVED_OTHER',
  THREAD_EVENT_APPROVED_SIGN = 'THREAD_EVENT_APPROVED_SIGN',
  THREAD_EVENT_SHOW_GROUP_APPROVED_SIGN = 'THREAD_EVENT_SHOW_GROUP_APPROVED_SIGN',
  THREAD_EVENT_REQUEST_ADMIN = 'THREAD_EVENT_REQUEST_ADMIN',
  THREAD_EVENT_MESSAGE = 'THREAD_EVENT_MESSAGE',
  THREAD_EVENT_IMAGE = 'THREAD_EVENT_IMAGE',
  THREAD_EVENT_FILE = 'THREAD_EVENT_FILE',
  THREAD_EVENT_UPDATED = 'THREAD_EVENT_UPDATED',
  THREAD_EVENT_SHOW_GROUP_UPDATED = 'THREAD_EVENT_SHOW_GROUP_UPDATED',
  THREAD_EVENT_CANCELLED = 'THREAD_EVENT_CANCELLED',
  THREAD_EVENT_SHOW_GROUP_CANCELLED = 'THREAD_EVENT_SHOW_GROUP_CANCELLED',
  THREAD_EVENT_SET_DATE = 'THREAD_EVENT_SET_DATE',
  THREAD_EVENT_SET_SHOWS = 'THREAD_EVENT_SET_SHOWS',
  THREAD_EVENT_SET_PLATFORM = 'THREAD_EVENT_SET_PLATFORM',
  THREAD_EVENT_SET_TICKET = 'THREAD_EVENT_SET_TICKET',
  THREAD_EVENT_SET_PROMO = 'THREAD_EVENT_SET_PROMO',
  THREAD_EVENT_SET_OTHER = 'THREAD_EVENT_SET_OTHER',
  THREAD_EVENT_ADDED_RECORDING_LINK = 'THREAD_EVENT_ADDED_RECORDING_LINK',
  THREAD_EVENT_UPDATED_FIELD = 'THREAD_EVENT_UPDATED_FIELD',
  THREAD_EVENT_UPDATED_MULTIPLE_FIELDS = 'THREAD_EVENT_UPDATED_MULTIPLE_FIELDS',
  SHOW_MESSAGE = 'SHOW_MESSAGE',
  SHOW_IMAGE = 'SHOW_IMAGE',
  SHOW_FILE = 'SHOW_FILE',

  // For v3 shows
  SHOW_EVENT_START = 'SHOW_EVENT_START',
  SHOW_EXTERNAL_EVENT_START = 'SHOW_EXTERNAL_EVENT_START',
  SHOW_EVENT_SIGNED = 'SHOW_EVENT_SIGNED',
  SHOW_EVENT_PUBLISHED = 'SHOW_EVENT_PUBLISHED',
  SHOW_EVENT_UPDATED = 'SHOW_EVENT_UPDATED',
  SHOW_EVENT_DELETED = 'SHOW_EVENT_DELETED',
}

export enum TicketStatuses {
  AVAILABLE = 'available',
  COMPED = 'comped',
  PURCHASED = 'purchased',
  RETURNED = 'returned',
  PASS = 'pass',

  /**
   * A deprecated ticket is one that was marked as reserved at the time the ticket capacity was being reduced.
   * Guests that are actively purchasing a deprecated ticket may continue to purchase them,
   * but if they bail out of checkout these may no longer be purchased.
   */
  DEPRECATED = 'deprecated',
}

export enum ProfileTypes {
  ACT = 'artist',
  VENUE = 'venue',
  PENDING = 'pending',
}
